export function OutlineEditIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0001 13.9954V18.9974C18.0001 20.1015 17.1073 20.9943 16.0032 20.9943H4.99597C3.89189 20.9943 2.99902 20.1015 2.99902 18.9974V7.99499C2.99902 6.89091 3.89189 5.99805 4.99597 5.99805H9.99794"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.878 7.94469L16.0505 5.11719L10.3921 10.7756L13.2196 13.6031L18.878 7.94469Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5832 4.41205L19.5866 4.41545C20.3673 5.19615 20.3673 6.45885 19.5866 7.23956L18.8772 7.94898L16.0497 5.12148L16.7591 4.41205C17.5398 3.63135 18.8025 3.63135 19.5832 4.41205Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8074 15.0189L8.26953 15.7246L8.97998 12.1915L10.3913 10.7754L13.2235 13.6028L11.8074 15.0189Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
